var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3715_13409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8919 2C6.96165 2 2.14868 6.48 2.14868 12C2.14868 17.52 6.96165 22 12.8919 22C18.8222 22 23.6352 17.52 23.6352 12C23.6352 6.48 18.8222 2 12.8919 2ZM12.8919 20C8.15416 20 4.29733 16.41 4.29733 12C4.29733 7.59 8.15416 4 12.8919 4C17.6297 4 21.4865 7.59 21.4865 12C21.4865 16.41 17.6297 20 12.8919 20ZM17.8231 7.58L10.7433 14.17L7.96078 11.59L6.44598 13L10.7433 17L19.3379 9L17.8231 7.58Z",
    fill: "#605DEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3715_13409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7838,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/Check_circle.31c1d0a6fc1278a71306d2f921ec0326.svg";
export { ForwardRef as ReactComponent };